export const customSortingOrder = [
    "Omsætning i alt",
    "Underleverendører",
    "Varekøb",
    "Fremmed arbejde",
    "Lønninger ialt",
    "Autodrift ialt",
    "Produktionsomkostninger",
    "Dækningsbidrag",
    "Administrationsomkostninger",
    "Periodens resultat",
    "Debitorer",
    "Varekreditorer",
    "Kreditor",
    "Bank",
  ];